import { useContext } from 'react'
import { MindMapContext } from './MindMapContextDef'

/**
 * Hook to access MindMapContext
 * Throws error if used outside of MindMapProvider
 */
export function useMindMapContext() {
  const context = useContext(MindMapContext)
  if (!context) {
    throw new Error('useMindMapContext must be used within a MindMapProvider')
  }
  return context
}
